/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type LegalObligationReason = typeof LegalObligationReason[keyof typeof LegalObligationReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalObligationReason = {
  MunicipalLaw: 'MunicipalLaw',
  PoliceLaw: 'PoliceLaw',
  CriminalProcedure: 'CriminalProcedure',
  GeneralTaxLaw: 'GeneralTaxLaw',
  CivilProcedure: 'CivilProcedure',
  Suwi: 'Suwi',
  Cbs: 'Cbs',
  EcCompetionClaimsLaw: 'EcCompetionClaimsLaw',
  Guardianship: 'Guardianship',
  Wibon: 'Wibon',
  Other: 'Other',
} as const;
